
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Utility for merging Tailwind classes
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Browser detection
export const isBrowser = typeof window !== 'undefined';

// Ensure URL has protocol for proper external linking
export function ensureUrlProtocol(url: string): string {
  if (!url) return '';
  return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
}

// Date formatting utility
export function formatDate(
  input: string | number | Date,
  options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    year: "numeric",
  }
): string {
  const date = input instanceof Date ? input : new Date(input);
  return new Intl.DateTimeFormat("en-US", {
    ...options,
  }).format(date);
}

// Currency formatting utility - DEPRECATED: Use formatCurrency from @/lib/portfolioCalculations instead
export function formatCurrency(
  amount: number,
  options: {
    currency?: string;
    notation?: Intl.NumberFormatOptions["notation"];
    maximumFractionDigits?: number;
    minimumFractionDigits?: number;
  } = {}
): string {
  const {
    currency = "USD",
    notation = "standard",
    maximumFractionDigits = 2,
    minimumFractionDigits = 2,
  } = options;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    notation,
    maximumFractionDigits,
    minimumFractionDigits,
  }).format(amount);
}

// Check if viewport is small (mobile or small tablet)
export function isSmallViewport(breakpoint = 768): boolean {
  if (!isBrowser) return false;
  return window.innerWidth < breakpoint;
}

// More utility functions can be added here as needed
